import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seoGlobals from '../seo_globals.json';

const SchemaOrg: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const baseUrl = seoGlobals.technical.baseUrl || 'https://vanity.co.at';
        const cleanPath = location.pathname.startsWith('/') ? location.pathname : `/${location.pathname}`;
        const canonicalUrl = location.pathname === '/' ? baseUrl : `${baseUrl}${cleanPath}`;
        const brand = seoGlobals.brand;
        const contact = seoGlobals.contact;

        const webPageNode = {
            '@type': 'WebPage',
            '@id': `${canonicalUrl}#webpage`,
            url: canonicalUrl,
            name: document.title || seoGlobals.seo.defaultTitle,
            description: seoGlobals.seo.defaultDescription,
            isPartOf: { '@id': `${baseUrl}/#website` },
            about: { '@id': `${baseUrl}/#organization` },
            inLanguage: seoGlobals.locales.default === 'de' ? 'de-AT' : 'en-US'
        };

        const localBusinessNode = {
            '@type': 'LocalBusiness',
            '@id': `${baseUrl}/#localbusiness`,
            name: brand.legalName || brand.name,
            url: baseUrl,
            telephone: contact.phone,
            email: contact.email,
            address: {
                '@type': 'PostalAddress',
                streetAddress: contact.address.street,
                addressLocality: contact.address.city,
                addressRegion: contact.address.region,
                postalCode: contact.address.postalCode,
                addressCountry: contact.address.country
            },
            geo: seoGlobals.schema.organization.location?.geo,
            sameAs: [seoGlobals.social.facebook, seoGlobals.social.instagram].filter(Boolean)
        };

        const breadcrumbNode = {
            '@type': 'BreadcrumbList',
            '@id': `${canonicalUrl}#breadcrumb`,
            itemListElement: [
                {
                    '@type': 'ListItem',
                    position: 1,
                    name: 'Home',
                    item: baseUrl
                },
                ...(location.pathname !== '/' ? [
                    {
                        '@type': 'ListItem',
                        position: 2,
                        name: canonicalUrl.replace(baseUrl, '').replace('/', '') || 'Page',
                        item: canonicalUrl
                    }
                ] : [])
            ]
        };

        const graph = {
            '@context': 'https://schema.org',
            '@graph': [
                seoGlobals.schema.website,
                seoGlobals.schema.organization,
                localBusinessNode,
                webPageNode,
                breadcrumbNode
            ]
        };

        const scriptId = 'vanity-schema-graph';
        let script = document.getElementById(scriptId) as HTMLScriptElement;

        if (!script) {
            script = document.createElement('script');
            script.id = scriptId;
            script.type = 'application/ld+json';
            document.head.appendChild(script);
        }

        script.text = JSON.stringify(graph);
    }, [location]);

    return null;
};

export default SchemaOrg;